import { faXmark } from '@fortawesome/pro-light-svg-icons';
import Button from '@veeva/corgix/button';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButtonWithRef from '../../../common/components/IconButton';
import OverlayContext from '../../../common/containers/OverlayContext';
import {
    licenseInformationCloseOverlayButtonCSS,
    licenseInformationHeaderMobileCSS,
    licenseInformationHeaderTextMobileCSS,
    licenseInformationMobileCSS,
    licenseInformationMobileFooterCSS,
} from './styles/LicenseInformationMobile.styles';

export default function LicenseInformationMobileDialog({ children }) {
    const { setOverlay } = useContext(OverlayContext);

    const handleClose = () => {
        setOverlay(null);
    };

    return (
        <div css={licenseInformationMobileCSS}>
            <div css={licenseInformationHeaderMobileCSS}>
                <div css={licenseInformationHeaderTextMobileCSS}>License Information</div>
                <IconButtonWithRef
                    icon={faXmark}
                    title="Close"
                    css={licenseInformationCloseOverlayButtonCSS}
                    iconSize="md"
                    onClick={handleClose}
                />
            </div>
            {children}
            <div css={licenseInformationMobileFooterCSS}>
                <Button variant="ghost" onClick={handleClose}>
                    Close
                </Button>
            </div>
        </div>
    );
}

LicenseInformationMobileDialog.propTypes = {
    children: PropTypes.node.isRequired,
};
